import { APISettings } from '../config.js';
import loginMethods from '../resources/loginMethods.js'

export default {
    name: "systemMethods",

    async getUsers() {
        //console.log("Starting request");
        try {
            const response = await fetch("/backend/users", {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                }
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async saveUser(obj) {
        try {
            const response = await fetch("/backend/users", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async updateUser(obj) {
        try {
            const response = await fetch("/backend/users/" + obj.id, {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    }, 
    async deleteUser(obj) {
        try {
            const response = await fetch("/backend/users/" + obj.id, {
                method: 'DELETE',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async resetPasswordFromLogged(obj){
        try {
            const response = await fetch("/backend/resetPasswordFromLogged/", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    }

}